import type { Ref } from 'react'

import { AWXConnectedAccountStatus, AwxConnectedAccountType } from '@ankor-io/common/types/awx'
import { Badge, Divider, Loading } from '@ankor-io/ui-components'

import ConnectedAccountCardChecker from './connected-account-card-checker'
import { ConnectedAccountCardsReconcile } from './connected-account-cards-reconcile'
import { ConnectedAccountCardsTable } from './connected-account-cards-table'
import { ConnectedAccountGlobalAccounts } from './connected-account-global-accounts'

export type CardsTableConnectedAccount = {
  id: string
  type: AwxConnectedAccountType
  name: string
  status: AWXConnectedAccountStatus
}

export default function ConnectedAccountCards({
  orgId,
  vesselId,
  connectedAccount,
  headingRef,
}: {
  orgId: string
  vesselId: string
  connectedAccount: CardsTableConnectedAccount
  /** Focused and scrolled to when the section is revealed, so the click has clear feedback. */
  headingRef?: Ref<HTMLHeadingElement>
}) {
  return (
    <div>
      <h3
        ref={headingRef}
        tabIndex={-1}
        className="font-bold text-md focus-visible:outline-none"
      >
        Cards
      </h3>
      <Divider className="mb-8" />
      <div className="flex justify-between">
        <div>
          <h4 className="font-bold text-sm">
            Cards for Connect Account: <Badge color="gray">{connectedAccount.id}</Badge>
          </h4>
          <h5 className="text-sm mt-2 font-light">Vessel: {connectedAccount.name}</h5>
        </div>

        <div className="mr-8">
          <ConnectedAccountCardChecker
            connectedAccountId={connectedAccount.id}
            orgId={orgId}
            vesselId={vesselId}
          />
        </div>
      </div>

      <Divider className="my-8" />
      <ConnectedAccountGlobalAccounts
        connectedAccountId={connectedAccount.id}
        orgId={orgId}
        vesselId={vesselId}
      />

      <Divider className="my-8" />
      <ConnectedAccountCardsReconcile
        connectedAccountId={connectedAccount.id}
        orgId={orgId}
        vesselId={vesselId}
      />

      <ConnectedAccountCardsTable
        connectedAccountId={connectedAccount.id}
        orgId={orgId}
        vesselId={vesselId}
      />
    </div>
  )
}
